module.exports = __webpack_public_path__ + "static/img/2022gxjsqyzs.1b03774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/2022gxjsqyzs.jpg
// module id = 7qPc
// module chunks = 1